<app-zones-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-zones-filters>

<div class="table-container">
   <table mat-table matSort [dataSource]="zones" multiTemplateDataRows matSortDisableClear matSortDirection="asc">

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Nome </th>
            <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
        </ng-container>

        <ng-container matColumnDef="shipping_cost">
            <th mat-header-cell *matHeaderCellDef> Costo Zona </th>
            <td mat-cell *matCellDef="let element"> {{ element.shipping_cost }} </td>
        </ng-container>

        <ng-container matColumnDef="radius">
            <th mat-header-cell *matHeaderCellDef> Raggio </th>
            <td mat-cell *matCellDef="let element"> {{ element.radius }} </td>
        </ng-container>

        <ng-container matColumnDef="latitude">
            <th mat-header-cell *matHeaderCellDef> Latitudine </th>
            <td mat-cell *matCellDef="let element"> {{ element?.latitude }} </td>
        </ng-container>

        <ng-container matColumnDef="longitude">
            <th mat-header-cell *matHeaderCellDef> Longitudine </th>
            <td mat-cell *matCellDef="let element"> {{ element?.longitude }} </td>
        </ng-container>

        <ng-container matColumnDef="tenant_id">
            <th mat-header-cell *matHeaderCellDef> Punto Vendita </th>
            <td mat-cell *matCellDef="let element">  {{ getTenant(element) }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="add-icon-container">
              <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo orario di apertura"
                (click)="$event.stopPropagation(); addZone()" color="primary">
                <mat-icon>add</mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let row" class="modify-icon-container">
              <ng-container>
                <button mat-icon-button (click)="$event.stopPropagation(); editZone(row)">
                  <mat-icon matTooltip="Modifica">create</mat-icon>
                </button>
              </ng-container>
              <!-- <button mat-icon-button (click)="$event.stopPropagation(); deleteTimeSlot(row)">
                <mat-icon matTooltip="Elimina">delete</mat-icon>
              </button> -->
            </td>

          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editZone(row)"></tr>
   </table>

   <mat-paginator     [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSizeOptions[0]"
  [length]="total | async">
  </mat-paginator>

</div>
